import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesRefunds } from "../../constants";
import { IRefund } from "../../financial.types";

export const requestRefunds = async (
  params: GetListRequestParams
): Promise<GetListResponse<IRefund>> => {
  return await instance.get(ApiRoutesRefunds.Refunds, {
    params
  });
};
